import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { UserCompanyService } from '../../nav-menu/user-company.service';
import { Title } from '@angular/platform-browser';
import { SubSink } from 'subsink';
import { Contact } from '../../contacts/contact/contact.model';
import { map } from 'rxjs/internal/operators/map';
import { UnsubscriberEditComponent, Resubscriber } from '../unsubscriber-edit/unsubscriber-edit.component';
import { Unsubscriber } from './unsubscriber.model';


declare var $: any;
declare var Toast: any;

@Component({
  selector: 'unsubscriber',
  templateUrl: './unsubscriber.component.html',
  styleUrls: ['./unsubscriber.component.css']
})

export class UnsubscriberComponent implements OnInit, OnDestroy {
  private dataTable: any;
  private dtOptions: any;
  private dtTable: any;
  private contacts: Contact[] = [];
  private navbarHeadline: any;
  private selectedCompany: number;
  private selectCompanyHtmlElement: any;
  private subs = new SubSink();

  @ViewChild('editModal', { static: false }) editModal: UnsubscriberEditComponent;

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService, private titleService: Title) { }

  ngOnInit() {
    this.navbarHeadline = $('#navbarHeadline');
    this.selectCompanyHtmlElement = $('#selectCompanyDropdown');
    this.dataTable = $('#usubscribers');
    this.createDataTable();

    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(resp => {
      this.selectedCompany = resp;
      this.loadData();
    });
  }

  private loadData() {
    this.subs.sink = this.repository.get<Contact[]>('api/Admin/Unsubscribers').pipe(map(x => x.data)).subscribe(resp => {
        this.contacts = resp;
        this.createDataTable();
      });
  }

  private createDataTable() {
    var that = this;

    var dtOptions = {
      data: this.contacts,
      columns: [
        {
          name: 'id',
          visible: false

        },
        {
          name: 'email',
          width: '250px'
        },
        {
          name: 'phone',
          width: '150px'
        },
        {
          name: 'isEmailConfirmed',
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'isActive',
          width: '100px',
          class: 'text-center',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          boolTrueDisplay: 'Active',
          boolFalseDisplay: 'Inactive',
          useFalseIcon: true
        },
        {
          name: 'insAt',
          width: '100px'
        },
        {
          name: 'contactLists',
          width: '300px'
        }
      ],
      orderBy: [[0, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-user-check pr-3"></i> Resubscribe',
          class: 'resubscriberow',
          dataAttributes: ['id'],
          action: function (id) {
            that.resubscribe(id);
          }
        }]
      }
    };

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private resubscribe(id: number) {
    let contact = this.contacts.find(x => x.id == id);

    if (contact) {
      this.subs.sink = this.repository.get<Unsubscriber>('api/Admin/UnsubscriberDetails/' + contact.id).subscribe(resp => {
        if (resp.hasErrors) {
          Toast.Show(resp.error, 'Resubscribe user', 'error');
        } else {
          this.editModal.show(resp.data);
        }
      });
    }
  }

  private onSaved(data: Resubscriber) {
    let unsubscriber = this.contacts.find(x => x.id == data.id);
    let index = this.contacts.indexOf(unsubscriber);

    if (unsubscriber) {
      let contactListsName = data.selectedContactList.map(x => x.name);

      contactListsName.forEach(cln => {
        if (unsubscriber.contactLists.indexOf(cln) !== -1) {
          let index = unsubscriber.contactLists.indexOf(cln);
          unsubscriber.contactLists.splice(index, 1);
        }

        if (unsubscriber.contactLists.length == 0)
          this.contacts.splice(index, 1);
      
      });
    }

    this.createDataTable();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

